import EventEmitter from 'events'
import jwt_decode from "jwt-decode";
import API from './api'
import { store } from "../redux/storeConfig/store";
import { getCurrentOrganization } from "../redux/actions/organization"
import { updateUserInfo } from "../redux/actions/auth/loginActions"
import { history } from "../history"

const localStorageKey = 'loggedIn'
const tokenExpiryKey = 'tokenExpiry'
const tokenyKey = 'growth-token'
// const loginEvent = 'loginEvent'



class AuthService extends EventEmitter {
    idToken = null;
    profile = null;
    tokenExpiry = null;

    // Starts the user login flow
    login (loginData) {
      // store.commit('RESET_ACL');
      return API({
        url:'signin',
        method:'POST',
        data:loginData
      });

    }

    userInfo(){
      if(this.isAuthenticated){
        return JSON.parse(localStorage.getItem("userInfo"))
      }
    }

    checkLogin(){
      // return store.getters.isLoggedIn
    }

    localLogin (userInfo) {
      return new Promise((resolve, reject)=>{
        const token = userInfo.accessToken;
        var decodedToken = jwt_decode(token);
        const expires_in = decodedToken.exp * 1000;
        this.tokenExpiry = new Date(expires_in)

        localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
        localStorage.setItem(tokenyKey, userInfo.accessToken)
        localStorage.setItem(localStorageKey, 'true')
        localStorage.setItem("userInfo", JSON.stringify(userInfo))


        if(userInfo.org_public_id && userInfo.org_public_id != ""){
          store.dispatch(
            getCurrentOrganization({
            org_public_id: userInfo.org_public_id
          })).then(res => {
            store.dispatch(updateUserInfo(userInfo))
            resolve(res)
          }).catch(err => {
            reject(err)
          });
        }else{
          resolve(true)
        }
      });

      // store.commit('UPDATE_USER_INFO',userInfo)
    }

    localLogOut () {
      localStorage.removeItem(localStorageKey)
      localStorage.removeItem(tokenExpiryKey)
      localStorage.removeItem('userInfo')
      localStorage.removeItem('globalOrganization')

      this.idToken = null
      this.tokenExpiry = null
      this.profile = null
    }

    logOut () {
      return new Promise((resolve, reject) => {
        const env = process.env.NODE_ENV
        // vue.$http({url:vue.$baseUrl+'logout',method:'POST'})
        localStorage.removeItem(tokenyKey)
        localStorage.removeItem(localStorageKey)
        localStorage.removeItem(tokenExpiryKey)
        localStorage.removeItem('userInfo')
        localStorage.removeItem('globalOrganization')
        // store.commit('RESET_ACL');
        this.idToken = null
        this.tokenExpiry = null
        this.profile = null
        if(env == 'development'){
          history.push('/login');
        } else {
          window.location.href = 'https://www.growthsayer.com';
        }

        setTimeout(() => {
          window.location.reload()
        }, 300);
        resolve();
      })
    }

    isAuthenticated () {
      const token = localStorage.getItem(tokenyKey);
      if (token){
          var decodedToken = jwt_decode(token);
          const expires_in = decodedToken.exp * 1000;
          console.log(' isAuthenticated; ',  Date.now() < expires_in && localStorage.getItem(localStorageKey) === 'true')
          return (
          Date.now() < expires_in && localStorage.getItem(localStorageKey) === 'true'
          // new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey)) && localStorage.getItem(localStorageKey) === 'true'
          )
      }
      return false ;

    }
    setAuthenticationHeader(token){
      // vue.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
      localStorage.setItem('savi-token',token)
    }

    forgotPassword(requestData){
        return API({
        url:'forget-password',
        method:'POST',
        data:requestData
      });
    }

    checkResetPasswordLinkExpiry(hash){
      // return vue.$http({url:vue.$baseUrl+'check-reset-password-token',method:'POST',data:{resetToken:hash}})
    }

    resetPassword(requestData){
      return API({
        url:'reset-password',
        method:'POST',
        data:requestData
      });
    }

    setRememberLoginData(loginData){
      localStorage.setItem('rememberData',JSON.stringify(loginData))
    }
    removeRememberLoginData(){
      localStorage.removeItem('rememberData')
    }
    changePassword(dataObj){
      return API({
        url: "change-password",
        method: "POST",
        data: dataObj
      });
    }

    updateLocalUserProfile(profile) {
      const exisitingProfile = this.userInfo()
      const newProfile = {...exisitingProfile, ...profile}

      localStorage.setItem("userInfo", JSON.stringify(newProfile))
    }

    updateUserInfo(userObj){
      if(this.isAuthenticated){
        return JSON.parse(localStorage.getItem("userInfo"))
      }
    }
}

export default new AuthService()
